/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TradingType {
    SPOT = 'Spot',
    DERIVATIVES = 'Derivatives',
    EARN = 'Earn',
    STOCK = 'Stock',
    PAYMENT_CARD = 'PaymentCard',
}
